import "./Login.css";
import React from "react";
import { images } from "../../../Assets/assetsHelper";
import LoginForm from "../../../Components/Organisms/Forms/LoginForm/LoginForm";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box, Link, Typography } from "@mui/material";
import config from "../../../config";

function Login({ accountCode }) {
  return (
    <div className="LoginPage">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: { xs: "0px", md: "10px 20px" },
          alignItems: "center",
        }}
      >
        <img src={config.APP_LOGO} alt="Logo" className="LoginLogo" />
        <Breadcrumbs className="LoginBreadcrumbs">
          <Typography sx={{}}>Registration</Typography>
          <Typography sx={{ color: "text.primary" }}>Sign In</Typography>
        </Breadcrumbs>
      </Box>
      <div className="signInContainer">
        <LoginForm accountCode={accountCode} />
      </div>
      <div className="signInDataContainer">
        <Typography
          sx={{
            color: "primary.main",
            fontSize: { xs: "26px", md: "35px" },
            fontWeight: "500",
          }}
        >
          Welcome!
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          This platform serves as a comprehensive solution for managing
          registrations for the{" "}
          <strong>
            {config.APP_NAME == "Code Reg"
              ? "Code Challenge Competition"
              : config.APP_NAME == "WeDo Reg"
              ? "WeDo Challenge Competition"
              : "International Robot Challenge Competition"}
          </strong>
          . Tailored for administrators and team managers, it provides an
          efficient and streamlined process to register teams, oversee
          participant and coach information, and manage payments, ensuring a
          seamless experience from start to finish.
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            fontWeight: "600",
            marginTop: "10px",
          }}
        >
          What You Can Do Here:
        </Typography>
        <ul style={{ marginLeft: "30px" }}>
          <li>Register your teams for the competition.</li>
          <li>Manage team details, including students and coaches.</li>
          <li>Handle payments and track registration statuses.</li>
        </ul>
        <Typography
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            fontWeight: "600",
            marginTop: "10px",
          }}
        >
          Need Assistance?
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          For account setup or registration help, please contact{" "}
          {config.APP_NAME == "Code Reg" ? (
            <a
              href="mailto:support@codechallenge-championship.org"
              style={{ textDecoration: "underline" }}
            >
              support@codechallenge-championship.org
            </a>
          ) : config.APP_NAME == "WeDo Reg" ? (
            <a
              href="mailto:support@wedochallenge.org"
              style={{ textDecoration: "underline" }}
            >
              support@wedochallenge.org
            </a>
          ) : (
            <a
              href="mailto:Internationalrobotchallenge1@gmail.com"
              style={{ textDecoration: "underline" }}
            >
              Internationalrobotchallenge1@gmail.com
            </a>
          )}
          .
        </Typography>
      </div>
    </div>
  );
}

export default Login;
